import filters from '@/mixins/filters.js'
import { download2 } from '@/common/util.js'

function createReportCharts(fbSer) {
  return {
    data() {
      return {
        toolbar: [
          {
            label: '广告系列',
            flag: 'campaign',
          },
          {
            label: '广告组',
            flag: 'adGroup',
          },
          {
            label: '广告',
            flag: 'ad',
          },
        ],
        dataType: 'campaign',
        activeClass: 'campaign',
        tishiName: '广告系列',
        activeName: '广告系列',
        interpretation:
          '广告系列由一系列广告组和广告构成，这些广告组和广告旨在实现同一个广告目标，即投放广告的目的，一个广告系列只能设置一个广告目标',
        condition: {},
        conditionPie: {},
        selectNum: 'IMPRESSIONS', //排序字段
        selectNumPie: 'IMPRESSIONS',
        dataList: [],
        column: [],
        loading: false,
        objectiveMapping: {
          帖文互动: {
            effectName: '帖文互动率',
          },
          赞: {
            effectName: '主页赞',
          },
          活动响应: {
            effectName: '活动响应',
          },
          Facebook站内潜在客户: {
            effectName: '潜在客户开发',
          },
          发起消息对话: {
            effectName: '消息互动量',
          },
          覆盖人数: {
            effectName: '覆盖人数',
          },
          链接点击: {
            effectName: '链接点击量',
          },
          '预估广告回想度提升（人数）': {
            effectName: '品牌知名度',
          },
        },
      }
    },
    methods: {
      // tab切换
      handleClick(val, name) {
        this.activeClass = val
        let interpretation = {
          campaign:
            '广告系列由一系列广告组和广告构成，这些广告组和广告旨在实现同一个广告目标，即投放广告的目的，一个广告系列只能设置一个广告目标',
          adGroup: `广告组是指共享投放方式、时机和版位设置的一组广告，可选择地区、性别和年龄等受众特征，设置预算和排期，并选择版位，广告组层级的设置会自动应用到其下的所有广告`,
          ad:
            '广告是由图片、视频、文本、链接等组成的具体广告创意，可以不同的形式进行最终展现',
        }
        this.tishiName = name
        this.activeName = name
        this.dataType = val
        this.interpretation = interpretation[val]
        let listName = this.activeClass + 'StatisticsList'
        this.dataList = this.fbData[listName]
        this.setColumn(this.activeName)
        this.setCondition()
        this.setConditionPie()
      },
      setselectNum(val) {
        this.selectNum = val
        this.getReportData()
      },
      setselectNumPie(val) {
        this.selectNumPie = val
        this.getReportDataPie()
      },

      // 配置condition
      setCondition() {
        let tabName = this.activeClass + 'ChartList'
        let that = this
        this.condition = {
          startDate: that.startDate,
          endDate: that.endDate,
          type: that.selecttimetype,
          sortDTO: {
            field: that.selectNum,
            sort: 'DESC',
          },
          tabItem: that.activeClass,
          tabName: that.activeName,
          data: that.fbData[tabName],
        }
      },
      setConditionPie() {
        let tabName = this.activeClass + 'ChartList'
        let that = this
        this.conditionPie = {
          startDate: that.startDate,
          endDate: that.endDate,
          type: that.selecttimetype,
          sortDTO: {
            field: that.selectNumPie,
            sort: 'DESC',
          },
          tabItem: that.activeClass,
          tabName: that.activeName,
          data: that.fbDataPie[tabName],
        }
      },

      // 配置column
      setColumn(val) {
        const { activeClass } = this
        const that = this
        const label_bind = (label, bind) => {
          return { label, bind }
        }
        const dynamicTableHeader = () => {
          let dynamicList = {
            campaign: [label_bind('广告系列', 'campaignName')],
            adGroup: [
              label_bind('广告系列', 'campaignName'),
              label_bind('广告组', 'adGroupName'),
            ],
            ad: [
              label_bind('广告系列', 'campaignName'),
              label_bind('广告组', 'adGroupName'),
              {
                label: '广告',
                type: 'custInfo',
                text: [
                  {
                    bind: 'adName',
                  },
                ],
              },
            ],
          }
          return dynamicList[activeClass]
        }
        const custStyle = () => {
          return {
            color: '#999999',
            fontSize: '14px',
          }
        }
        let tempCol = [
          {
            label: '展示次数',
            width: 150,
            content: '广告在屏幕上展示的次数',
            bind: 'impressions',
            align: 'left',
            type: 'percentage',
            dataStyle(val) {
              return filters.filters.thousands(val)
            },
          },
          {
            label: '成效',
            bind: [
              {
                bind: 'effect',
              },
              {
                bind: 'facebookObjectiveStr',
                // custValue(row) {
                //   return that.objectiveMapping[row.facebookObjectiveStr]
                //     .effectName
                // },
                custStyle(row) {
                  return custStyle()
                },
              },
            ],
            content:
              '根据选中目标和设置，广告实现成效的次数。如目标为“流量”，则成效为“链接点击”目标为“主页赞”，则成效为“赞”',
            align: 'left',
            type: 'percentage',
            dataStyle(val) {
              return filters.filters.thousands(val)
            },
          },
          {
            label: '覆盖人数',
            width: 150,
            content:
              '至少查看广告一次的用户数量。覆盖人数与展示次数不同，后者可能存在同一用户多次浏览广告的情况。此处未对同一用户多天浏览广告的情况进行过滤',
            bind: 'covers',
            align: 'left',
            type: 'percentage',
            dataStyle(val) {
              return filters.filters.thousands(val)
            },
          },
          {
            label: '成效获得率',
            content:
              '获得的成效在所有广告查看量中所占的百分比。计算方式：成效/展示次数*100%',
            bind: [
              {
                bind: 'effectiveRate',
                custValue(row) {
                  return filters.filters.jojint(row.effectiveRate)
                },
              },
              {
                bind: 'facebookObjectiveStr',
                custStyle(row) {
                  return custStyle()
                },
              },
            ],
            align: 'left',
            type: 'percentage',
            dataStyle(val) {
              return filters.filters.jojint(val)
            },
          },
          {
            label: '成效均价',

            content: '广告投放带来的每次成效的平均费用',
            bind: [
              {
                bind: 'effectOnAverage',
                custValue(row) {
                  return filters.filters.rmb(row.effectOnAverage)
                },
              },
              {
                bind: 'singleFacebookObjectiveStr',
                custStyle(row) {
                  return custStyle()
                },
              },
            ],
            align: 'right',
            type: 'percentage',
            style: {
              textAlign: 'right',
            },
            dataStyle(val) {
              return filters.filters.rmb(val)
            },
          },
          {
            label: '消耗',
            content: '筛选时间周期内总支出，美金结算，以消耗当天汇率换算人民币',
            bind: 'exchangeRateCost',
            align: 'right',
            type: 'percentage',
            width: 140,
            style: {
              textAlign: 'right',
            },
            dataStyle(val) {
              return filters.filters.rmb(val)
            },
          },
        ]
        this.column = dynamicTableHeader().concat(tempCol)
      },
      // 下载
      async googlederive() {
        let { startDate, endDate, selecttimetype, selectNum, serviceId } = this
        let dataType =
          this.dataType == 'adGroup'
            ? 'AD_GROUP'
            : this.dataType.toLocaleUpperCase()
        let param = {
          serviceId,
          dataType,
          startDate,
          endDate,
          type: selecttimetype,
          sortDTO: {
            field: selectNum,
            sort: 'DESC',
          },
        }
        try {
          let res = await fbSer.exportReport(param, serviceId)
          download2(
            res.data,
            `Facebook Ads广告报告【${this.startDate}至${this.endDate}】.xlsx`
          )
        } catch (e) {
          console.error(e)
        }
      },
    },
  }
}
export default createReportCharts
